import React, { useState } from 'react';
import styled from 'styled-components';
import NavBannerDesktop from './common/NavBannerDesktop';
import RebrandedNavigation from './desktop/RebrandedNavigation';
import NavigationMobile from './mobile/RebrandedMenuMobile/NavigationMobile';
import SearchWrapper from './SearchWrapper';
import useSale from '@/hooks/useSale';

const Wrapper = styled.div`
  .nav-banner-desktop {
    z-index: 1002;
  }

  .t-hide-mobile {
    @media (max-width: 1239px) {
      display: none;
    }
  }

  .t-hide-desktop {
    @media (min-width: 1240px) {
      display: none;
    }
  }

  @media (max-width: 992px) {
    top: 0;
    background: white;
    position: sticky;
    z-index: 9;
    top: 0px;
    width: 100%;
  }
`;


export default function RebrandedNavigationContainer() {
  const [showSearch, setShowSearch] = useState(false);
  const { isSale } = useSale();

  return (
    <Wrapper id="navigation">
      {isSale && (
        <div className="hide-on-mobile">
          <NavBannerDesktop className="nav-banner-desktop" />
        </div>
      )}
      <div className="t-hide-mobile">
        <RebrandedNavigation setShowSearch={setShowSearch} />
      </div>
      <div className="t-hide-desktop">
        <NavigationMobile setShowSearch={setShowSearch} />
      </div>
      <SearchWrapper showSearch={showSearch} setShowSearch={setShowSearch} />
    </Wrapper>
  );
}
